function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { ComponentBase } from "./Shared/ComponentBase";
import { FormFieldBuilder } from "./Helpers/FormFieldBuilder";
import { FormManager } from "./Helpers/FormManager";
import { SubscribeToPublicationApiService } from "./Services/SubscribeToPublicationApiService";
import { I18N } from "./Shared/I18n";
import { DropdownBuilder } from './Helpers/DropdownBuilder';
import { HouseholdApiService } from './Services/HouseholdApiService';
import { UserService } from './Services/UserService';
export var MPPSubscribeToPublication = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MPPSubscribeToPublication, _ComponentBase);

  var _super = _createSuper(MPPSubscribeToPublication);

  function MPPSubscribeToPublication() {
    var _this;

    _classCallCheck(this, MPPSubscribeToPublication);

    _this = _super.call(this);
    _this._publication = [];
    _this._needToUpdateContactEmail = false;
    return _this;
  }

  _createClass(MPPSubscribeToPublication, [{
    key: "loadAttributes",
    value: function loadAttributes() {
      this.verificationEmailTemplateID = this.getAttribute("verificationemailtemplateid") || "";
      this.returnUrl = this.getAttribute("returnurl") || "";
      this.publicationID = this.getAttribute("publicationid") || "";
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback() {} // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MPPSubscribeToPublication.WidgetDetails.tag);
    } // istanbul ignore next

  }, {
    key: "getFormFieldBuilder",
    value: function getFormFieldBuilder() {
      return new FormFieldBuilder();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  this._$emptyContainer.innerHTML = "";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                  this._$emptyContainer.innerHTML = "";
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n; // Setup div to handle any errors

                this._root.innerHTML = "\n\t\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\n\t\t\t\t<div class=\"mppw-component-container mpp-subscribe-to-publication\">\n\n\t\t\t\t<div id=\"emptyContainer\"><i class=\"mppw-spinner\"></i></div>\n\t\t\t\t<div id=\"detailsContainer\"></div>\n\n\t\t\t\t<div id=\"resultMessageContainer\" class=\"mppw-alert\" style=\"display: none;\">\n\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t<span id=\"resultMessageText\" class=\"mppw-alert__text\"></span>\n\t\t\t\t</div>\n\t\t\t\t</div>"); // Error/success message elements

                this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
                this._$resultMessageText = this._root.querySelector("#resultMessageText"); // Empty container, holds the loading spinner

                this._$emptyContainer = this._root.querySelector("#emptyContainer"); // Load attributes

                this.loadAttributes();
                this._subscribeToPublicationService = new SubscribeToPublicationApiService();
                this._formFieldBuilder = this.getFormFieldBuilder(); // Get publication based on publicationID

                this._getPublicationService(i18n);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }() // End connectedCallback

  }, {
    key: "_getPublicationService",
    value: function _getPublicationService(i18n) {
      var _this2 = this;

      return this._subscribeToPublicationService.GetPublication(this.publicationID).then(function (response) {
        if (response) {
          _this2._publication = response; // Check if returnUrl attribute has a value

          var href = window.location.href;
          var url = new URL(href);
          var mppVerifyId = url.searchParams.get("mpp-verify-id"); // Next check to see if returnUrl has a mppVerifyId= value set

          if (!!mppVerifyId) {
            // If so then display register page
            _this2._verifyEmailLink(i18n, mppVerifyId);
          } else {
            // Else display intitial verify form
            _this2.SetupInitialForm(i18n);
          }
        } else {
          _this2.SetMessage("warning", i18n.publicationDoesNotExist);
        }
      })["catch"](function (error) {
        //ErrorBuilder.RenderHandler(this._$emptyContainer, i18n);
        _this2.SetMessage("danger", i18n.getPublicationError);

        _this2._$emptyContainer.innerHTML = "";
      });
    }
  }, {
    key: "DisplayContactInfoForm",
    value: function DisplayContactInfoForm() {
      var _this3 = this;

      return UserService.GetCurrentUser().then(function (userInfo) {
        _this3._userInfo = userInfo;
        _this3._$subcribeAsContainer.style.display = "";
        _this3._$contactId.value = userInfo.contactId;

        _this3._getHouseHold();
      }, function () {
        _this3._$subcribeAsContainer.style.display = "none";

        _this3.FillContactInfoForm();
      });
    } // istanbul ignore next

  }, {
    key: "getHouseholdApiService",
    value: function getHouseholdApiService() {
      return new HouseholdApiService();
    }
  }, {
    key: "_getHouseHold",
    value: function _getHouseHold() {
      var _this4 = this;

      var householdService = this.getHouseholdApiService();
      householdService.GetHousehold().then(function (household) {
        _this4._members = household.familyMembers;

        if (!!_this4._members && _this4._members.length > 0) {
          var allMembers = _this4._members.map(function (member) {
            return {
              id: member.contactId,
              value: member.displayName
            };
          }); //Load family member dropdown


          DropdownBuilder.LoadDropdown(_this4._$subcribeAs, allMembers, "Blank Form");
        } else {
          // Family member data is null so just use contactInfo to populate dropdown
          // Use logged in users contact info to populate dropdowns
          var contactDropdown = [{
            id: _this4._userInfo.contactId,
            value: _this4._userInfo.user.displayName
          }]; //Load family member dropdown

          DropdownBuilder.LoadDropdown(_this4._$subcribeAs, contactDropdown, "Blank Form");
        } //Set default selected value


        _this4._$subcribeAs.value = _this4._userInfo.contactId;

        _this4.FillContactInfoForm(_this4._$subcribeAs.value);
      });
    }
  }, {
    key: "_verifyEmailLink",
    value: function _verifyEmailLink(i18n, mppVerifyId) {
      var _this5 = this;

      // Verify id
      return this._subscribeToPublicationService.VerifyEmailLink(mppVerifyId).then(function (verifyResponse) {
        var i18NMessage = _this5.GetI18NMessageByName(i18n, verifyResponse.i18NLabelName);

        if (verifyResponse.success === true) {
          _this5.SetMessage("success", i18NMessage, '[Publication_Title]', _this5._publication.title);
        } else {
          // Display warning message
          _this5.SetMessage("warning", i18NMessage);
        }
      })["catch"](function (error) {
        _this5.SetMessage("danger", i18n.verificationFailedMessage);
      })["finally"](function () {
        _this5._$emptyContainer.innerHTML = "";
      });
    }
  }, {
    key: "SetupInitialForm",
    value: function SetupInitialForm(i18n) {
      this._root.innerHTML = this.BuildRootInitialHtml(i18n);
      this.SetupInitialFormVariables(i18n); // Load logged in user

      this._userInfo = null; // If logged in user, show/hide blank contact form

      this.DisplayContactInfoForm();
    } // istanbul ignore next

  }, {
    key: "SetupInitialFormVariables",
    value: function SetupInitialFormVariables(i18n) {
      // Select items from template.  Use $ as convention indicating a DOM element:
      // InnerHTML
      this._$verfificationContainer = this._root.querySelector("#verfificationContainer");
      this._$visitDetailsContainer = this._root.querySelector("#visitDetailsContainer");
      this._$emptyContainer = this._root.querySelector("#emptyContainer");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText"); // Verification Form HTML

      this._$verificationForm = this._root.querySelector("#verificationForm");
      this._$verificationButton = this._root.querySelector("#verificationButton");
      this._$verificationBlankForm = this._root.querySelector("#verificationBlankForm");
      this._$verificationfirstNameText = this._root.querySelector("#verification_firstNameText");
      this._$verificationlastNameText = this._root.querySelector("#verification_lastNameText");
      this._$verificationemailText = this._root.querySelector("#verification_emailText");
      this._$subcribeAsContainer = this._root.querySelector("#subcribeAsContainer");
      this._$subcribeAs = this._root.querySelector("#subcribeAs");
      this._$contactId = this._root.querySelector("#ContactId");
      this._$emptyContainer.innerHTML = "";
      this.BindEventListeners(i18n);
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners(i18n) {
      var _this6 = this;

      // Wire-up event listeners:
      var verificationForm = new FormManager(this._$verificationForm);

      this._$verificationForm.addEventListener("submit", function (event) {
        event.preventDefault();

        if (verificationForm.IsValid()) {
          // Disable submit button to prevent duplicate submissions
          _this6.DisableVerificationButton(); // Hide any previous messages


          _this6.HideMessage();

          var formData = new FormData(_this6._$verificationForm);
          formData.append("ReturnUrl", _this6.returnUrl);

          _this6._sendVerificationEmail(formData, i18n, verificationForm);
        } else {
          _this6.SetMessage("warning", i18n.validationFailedMessage);
        }
      });

      this._$subcribeAs.addEventListener("change", function (e) {
        //Only show blank form if drop down value is null
        if (!!_this6._$subcribeAs.value) {
          _this6.FillContactInfoForm(_this6._$subcribeAs.value);
        } else {
          _this6.FillContactInfoForm();
        }
      });
    }
  }, {
    key: "_sendVerificationEmail",
    value: function _sendVerificationEmail(formData, i18n, verificationForm) {
      var _this7 = this;

      return this._subscribeToPublicationService.SendVerificationEmail(formData).then(function (sendEmailResponse) {
        var i18NMessage = _this7.GetI18NMessageByName(i18n, sendEmailResponse.i18NLabelName);

        if (sendEmailResponse.success === true) {
          // Display success message
          _this7.SetMessage("success", i18NMessage, '[Publication_Title]', _this7._publication.title);

          verificationForm.Reset();

          _this7.HideVerificationForm();

          _this7._$subcribeAsContainer.style.display = "none";
        } else {
          // Display warning message
          _this7.SetMessage("warning", i18NMessage);
        }
      })["catch"](function (error) {
        console.error(error);

        _this7.SetMessage("danger", i18n.verificationFailedMessage);
      })["finally"](function () {
        // Need to make sure to re-enable the button once finished
        _this7.EnableVerificationButton();
      });
    }
  }, {
    key: "ShowVerificationForm",
    value: function ShowVerificationForm() {
      this._$verificationForm.style.display = "";

      this._$verificationfirstNameText.setAttribute("required", true);

      this._$verificationlastNameText.setAttribute("required", true);

      this._$verificationemailText.setAttribute("required", true);
    }
  }, {
    key: "HideVerificationForm",
    value: function HideVerificationForm() {
      this._$verificationForm.style.display = "none";
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var replaceWith = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      if (replace) {
        message = message.replace(replace, replaceWith);
      }

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }, {
    key: "HideMessage",
    value: function HideMessage() {
      this._$resultMessageText.innerHTML = "";
      this._$resultMessageContainer.style.display = "none";
    }
  }, {
    key: "SetPhoneMask",
    value: function SetPhoneMask(htmlElementId) {
      var phoneMaskElement = this._root.getElementById(htmlElementId);

      phoneMaskElement.setAttribute("pattern", this._phoneMask);
    }
  }, {
    key: "DisableVerificationButton",
    value: function DisableVerificationButton() {
      this._$verificationButton.setAttribute("disabled", true);
    }
  }, {
    key: "EnableVerificationButton",
    value: function EnableVerificationButton() {
      this._$verificationButton.removeAttribute("disabled");
    }
  }, {
    key: "GetI18NMessageByName",
    value: function GetI18NMessageByName(i18n, name) {
      var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var replaceWith = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var keys = Object.keys(i18n);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];

        if (key === name) {
          var i18Message = i18n[key];
          return i18Message;
        }
      }
    }
  }, {
    key: "FillContactInfoForm",
    value: function FillContactInfoForm(contactId) {
      var _this8 = this;

      this._needToUpdateContactEmail = false;
      this._$firstName = this._root.querySelector("#FirstName");
      this._$lastName = this._root.querySelector("#LastName");
      this._$emailAddress = this._root.querySelector("#EmailAddress");
      this._$mobilePhone = this._root.querySelector("#MobilePhone");
      this._$firstNameForLabel = this._root.querySelector("#FirstNameForLabel");
      this._$lastNameForLabel = this._root.querySelector("#LastNameForLabel");
      this._$emailAddressForLabel = this._root.querySelector("#EmailAddressForLabel");
      this._$mobilePhoneForLabel = this._root.querySelector("#MobilePhoneForLabel");

      if (Number(contactId) > 0) {
        var member = this._members.find(function (x) {
          return Number(x.contactId) === Number(_this8._$subcribeAs.value);
        });

        if (member) {
          this._$contactId.value = member.contactId;
          var firstNameValue = member.firstName,
              lastNameValue = member.lastName,
              emailAddressValue = member.emailAddress,
              mobilePhoneValue = member.mobilePhoneNumber,
              contactIdValue = member.contactId;
          this._$firstName.style.display = "none";
          this._$lastName.style.display = "none";
          this._$mobilePhone.style.display = "none";
          this._$firstNameForLabel.style.display = "none";
          this._$lastNameForLabel.style.display = "none";
          this._$mobilePhoneForLabel.style.display = "none";
          this._$firstName.value = firstNameValue;
          this._$lastName.value = lastNameValue;
          this._$emailAddress.value = emailAddressValue;
          this._$mobilePhone.value = mobilePhoneValue;
          this._$verificationButton = this._root.querySelector("#verificationButton");

          if (emailAddressValue === null || emailAddressValue === '') {
            this._needToUpdateContactEmail = true;
            this._$contactId.value = contactIdValue;
            this._$emailAddress.style.display = "";
            this._$emailAddressForLabel.style.display = "";

            this._$verificationButton.classList.add("mpp-mt-10");
          } else {
            this._$emailAddress.style.display = "none";
            this._$emailAddressForLabel.style.display = "none";

            this._$verificationButton.classList.remove("mpp-mt-10");
          }
        }
      } else {
        this._$contactId.value = null;
        this._$firstName.style.display = "";
        this._$lastName.style.display = "";
        this._$emailAddress.style.display = "";
        this._$mobilePhone.style.display = "";
        this._$firstNameForLabel.style.display = "";
        this._$lastNameForLabel.style.display = "";
        this._$emailAddressForLabel.style.display = "";
        this._$mobilePhoneForLabel.style.display = "";
        this._$firstName.value = "";
        this._$lastName.value = "";
        this._$emailAddress.value = "";
        this._$mobilePhone.value = "";
      }
    }
  }, {
    key: "BuildRootInitialHtml",
    value: function BuildRootInitialHtml(i18n) {
      return "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\n\t\t\t<div class=\"mppw-component-container mpp-subscribe-to-publication\">\n\n\t\t\t\t<div id=\"emptyContainer\"><i class=\"mppw-spinner\"></i></div>\n\t\t\t\t<div id=\"detailsContainer\"></div>\n\n\t\t\t\t<div class=\"mpp-form--container\" id=\"formContainer\">\n\t\t\t\t\t<div id=\"verfificationContainer\">\n\t\t\t\t\t\t<div id=\"userHasVerificationContainer\"></div>\n\t\t\t\t\t\t").concat(this.BuildVerificationForm(i18n), "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t");
    }
  }, {
    key: "BuildVerificationForm",
    value: function BuildVerificationForm(i18n) {
      return "\n\t\t\t\t<div class=\"mpp-innerpage\">\n\t\t\t\t\t<h3>".concat(i18n.publicationDescription.replace("[Publication_Title]", this._publication.title), "</h3>\n\t\t\t\t\t<h5>").concat(this._publication.description || '', "</h5>\n\t\t\t\t</div>\n\t\t\t\t<div id=\"resultMessageContainer\" class=\"mppw-alert\" style=\"display: none;\">\n\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t<span id=\"resultMessageText\" class=\"mppw-alert__text\"></span>\n\t\t\t\t</div>\n\n\t\t\t\t<div id=\"subcribeAsContainer\" class=\"mppw-form-field mppw-form-field__static-container\" style=\"display: none\">\n\t\t\t\t\t<select name=\"subcribeAs\" id=\"subcribeAs\" class=\"mppw-form-field__control\" value=\"\"></select>\n\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"subcribeAs\">").concat(this._i18n.subcribeAsLabel, "*:</label>\n\t\t\t\t</div>\n\n\t\t\t\t<form id=\"verificationForm\" class=\"mppw-form mppw-form-validate\">\n\t\t\t\t\t<input type=\"hidden\" id=\"ContactId\" name=\"ContactId\" value=\"\" />\n\t\t\t\t\t<input type=\"hidden\" name=\"VerificationEmailTemplateID\" value=\"").concat(this.verificationEmailTemplateID || '', "\" />\n\t\t\t\t\t<input type=\"hidden\" name=\"PublicationID\" value=\"").concat(this.publicationID, "\" />\n\t\t\t\t\t<div id=\"verificationGroupDiv\">\n\t\t\t\t\t\t<div id=\"verificationBlankForm\">\n\t\t\t\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('FirstName', i18n.firstNameLabel, true, 'First Name Is Required'), "\n\t\t\t\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('LastName', i18n.lastNameLabel, true, 'Last Name Is Required'), "\n\t\t\t\t\t\t\t").concat(this._formFieldBuilder.BuildEmailInput('EmailAddress', i18n.emailAddressLabel, true, 'Email Address Is Required'), "\n\t\t\t\t\t\t\t").concat(this._formFieldBuilder.BuildPhoneInput('MobilePhone', i18n.mobilePhoneLabel, false, ''), "\n\t\t\t\t\t\t\t<div class=\"mppw-centered\">\n\t\t\t\t\t\t\t\t<input id=\"verificationButton\" type=\"submit\" class=\"mppw-btn primary\" value=\"").concat(i18n.submitVerificationButtonText, "\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t");
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Subscribe to Publications",
        tag: "mpp-subscribe-to-publication",
        configurationItems: [{
          name: "Publication ID",
          attribute: "publicationid",
          description: "Determines which Publication will be displayed.",
          required: true,
          type: "foreignkey",
          fkTable: "dp_Publications",
          fkFilter: "",
          fkSingleName: "Publication"
        }, {
          name: "Return URL",
          attribute: "returnurl",
          description: "URL the widget exists on. The verification email will use this to complete the subscription and display confirmation.",
          required: true,
          type: "url"
        }, {
          name: "Verification Email Template",
          attribute: "verificationemailtemplateid",
          description: "Email containing a verification link which will complete the subscription.",
          required: true,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["verificationemailtemplateid", "returnurl", "publicationid"];
    }
  }]);

  return MPPSubscribeToPublication;
}(ComponentBase);
MPPSubscribeToPublication.registerComponent(MPPSubscribeToPublication.WidgetDetails.tag, MPPSubscribeToPublication);